/**
 * index.js (central schema controller)
 * -----------------------------------
 * Public API:
 *   - ensureSchemaUpToDate(dbName?: string) -> Promise<Dexie>
 *   - collectConfigs() -> Promise<Config[]> (exposed for testing)
 *   - parseTriplet, cmpTriplet (re-exported)
 *
 * Strategy at startup:
 *   1) Collect config files from all features (JSON + JS)
 *   2) Normalize/merge them (latest MAJOR per store defines Dexie stores)
 *   3) Open Dexie with computed version (hash of store defs)
 *   4) For each store, apply timeline steps from previous -> latest
 *      (populate on first appearance, then coerce/model, then patch data)
 */

import { planAndMigrate } from "./migrator";
import {
  // loadConfigsWithRequireContext,
  collectConfigs,
  parseTriplet,
  cmpTriplet,
} from "./configLoader";

let __initPromise = null;

export async function ensureSchemaUpToDate(db, options = {}) {
  if (!__initPromise) {
    __initPromise = (async () => {
      const configs = await collectConfigs();
      configs.sort((a, b) => cmpTriplet(a.version, b.version));
      await planAndMigrate(db, configs, options);
      return db;
    })();
  }
  return __initPromise;
}

/**
 * Collects and normalizes all feature config files.
 * Uses `require.context` for Webpack builds.
 *
 * @returns {Promise<Array<{filePath:string, version:string, stores:Object<string,string>, model?:Object, data:Object[]}>>}
 */
// export async function collectConfigs() {
//   // Webpack-only loader
//   return loadConfigsWithRequireContext();
// }

/**
 * Ensures the database schema is up to date with the collected configs.
 * Safe to call on app boot; idempotent across runs (planner handles deltas).
 *
 * @returns {Promise<import('dexie').Dexie>} Open Dexie instance after migrations.
 */
// export async function ensureSchemaUpToDate(dbName = "pwa-app") {
// export async function ensureSchemaUpToDate(db) {
//   const configs = await collectConfigs();
//   console.log(configs);
//   configs.sort((a, b) => cmpTriplet(a.version, b.version));
//   // const db = await planAndMigrate(dbName, configs);
//   await planAndMigrate(db, configs);
//   return db;
// }

// export async function ensureSchemaUpToDate(db, options = {}) {
//   if (__initPromise) return __initPromise;
//   __initPromise = (async () => {
//     const configs = await collectConfigs();
//     console.debug(configs);
//     configs.sort((a, b) => cmpTriplet(a.version, b.version));
//     await planAndMigrate(db, configs, options);
//     return db;
//   })();
//   try {
//     return await __initPromise;
//   } finally {
//     __initPromise = null;
//   }
// }

// export { parseTriplet, cmpTriplet } from "./configLoader";
